import Textarea from './textarea'
import { CInput, Error, Label } from './Input'
import { CSelect } from './SelectInput'
import { FileSelectInput } from './FileSelectInput'
import { SwitchToggleInput2 } from './SwitchToggleInput'
import { ImageSelectInput } from './ImageSelectInput'
import Editor from './Editor'
import { CFieldProps } from '@velocity/shared'
import { useFormikContext } from 'formik'

export const CFields = ({ fields }: { fields: CFieldProps[] }) => {
  const { values } = useFormikContext() as any
  fields = fields.filter((field) => {
    if (values.id) return field.edit !== false
    else return field.create !== false
  })
  return (fields || []).map((field, i) => {
    return field.hidden ? null : (
        <div key={i} className={'relative ' + (field.className || '')}>
          <Label {...field} />
          {field.type === 'component' && field.component ?
            <field.component {...field} />
          : field.type === 'array' ?
            null
          : ['select', 'address'].includes(field.type!) ?
            <CSelect {...field} />
          : field.type === 'textarea' ?
            <Textarea {...field} />
          : field.type === 'file' ?
            <FileSelectInput {...field} />
          : field.type === 'image' ?
            <ImageSelectInput {...field} />
          : field.type === 'switch' ?
            <SwitchToggleInput2 {...field} />
          : field.type === 'editor' ?
            <></>
            // <Editor {...field} />
          : <CInput {...field} />}
          <Error name={field.name} />
        </div>
      )
  })
}
